import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';
import { PartnerApplySuccessComponent } from './partner-apply-success/partner-apply-success.component';

@AutoUnsubscribe()
@Component({
  selector: 'app-partner-apply',
  templateUrl: './partner-apply.component.html',
  styleUrls: ['./partner-apply.component.scss'],
})
export class PartnerApplyComponent implements OnInit, OnDestroy {
  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private spinner: NgxSpinnerService,
    private eventService: EventService
  ) {}

  ngOnInit(): void {
    this.eventService.mobileDisplayLogoToolbar.next(true);
  }

  private $subscription!: Subscription;

  async submit(value: any) {
    this.spinner.show();
    const response: any = await this.http
      .post(`${environment.partnerSignUp.partnerURL}/partners/signup`, value, {
        headers: new HttpHeaders().append(
          'app-key',
          environment.partnerSignUp.partnerKey
        ),
      })
      .toPromise();

    this.spinner.hide();

    if (response.status) {
      const dialog = this.dialog.open(PartnerApplySuccessComponent, {
        width: '512px',
      });

      dialog.afterClosed().subscribe(() => {
        this.router.navigate(['for-merchants']);
      });
    } else {
      this.snackbar.open(response.message, 'OK', { duration: 3000 });
    }
  }

  ngOnDestroy(): void {
    if (this.$subscription) this.$subscription.unsubscribe();
    clearInterval();
    clearTimeout();
  }
}
